module.exports = __webpack_public_path__ + "media/brands/lancia-ded86249.png";